import { find } from "lodash";
import { useCurrentUserProjects } from "@radarly/core/user/use-cases";

export function useGetCurrentUserProjectData(projectId: number) {
  const projects = useCurrentUserProjects();
  if (!projectId) {
    return null;
  }
  return find(projects, { id: projectId }) || null;
}
